export default "__VITE_ASSET__BwzWmUSh__"